<div class="container" [class.impaired]="isImpairedVersion">
  <div class="title mb24">
    <span [ngClass]="{ 'button1-impaired-text': isImpairedVersion, 'h3': !isImpairedVersion }">{{
      'DATA.CATALOG_ITEMS_DATA.PASSPORT.DATASET_UPDATE_HISTORY' | translate
    }}</span>
    <button class="btn-empty" (click)="close()">
      <svg
        [icon]="icons.Close"
        class="close-icon"
        [ngClass]="{ 'impaired-color svg32': isImpairedVersion, 'dark-gray-color svg24': !isImpairedVersion }"
      />
    </button>
  </div>
  <div class="body">
    <ng-container *ngFor="let file of downloadFiles; let first = first">
      <div
        *ngIf="file.status === statusArchive || file.status === statusSuccess"
        class="row"
        (click)="downloadFile(file.idFile, catalog.catalogName + ' версия ' + file.versionNum + '.' + file.releaseNum + ' от ' + file.releaseDate)"
      >
        <svg
          [icon]="icons.Downloaded"
          [matTooltip]="'OTHER.DOWNLOAD' | translate"
          [ngClass]="{ 'impaired-color svg32': isImpairedVersion, 'dark-gray-color svg24': !isImpairedVersion }"
        />
        <span [ngClass]="{ 'h3-impaired': isImpairedVersion, 'body-2 dark-color': !isImpairedVersion }" [matTooltip]="'OTHER.DOWNLOAD' | translate"
          >{{
            ('OTHER.VERSION' | translate) +
              ' ' +
              ' ' +
              file.versionNum +
              '.' +
              file.releaseNum +
              ' от ' +
              file.releaseDate +
              (file.releaseStatus === actualRelease ? ' (' + ('OTHER.ACTUAL' | translate) + ')' : '')
          }}
        </span>
      </div>
      <div
        [ngClass]="{ 'disable-svg': file.releaseStatus === 0 }"
        *ngIf="file.status !== statusArchive && file.status !== statusSuccess"
        class="row"
        (click)="file.status !== 'PROCESSING' && file.releaseStatus !== 0 ? createFile(file) : ''"
      >
        <svg
          *ngIf="file.status !== 'PROCESSING'"
          [matTooltip]="'OTHER.GENERATE_FILE' | translate"
          [icon]="icons.AddPlus"
          [ngClass]="{ 'svg32': isImpairedVersion, 'svg24': !isImpairedVersion, 'disable-svg': file.releaseStatus === 0 }"
          class="dark-gray-color"
        />

        <svg
          *ngIf="file.status === 'PROCESSING'"
          [matTooltip]="'OTHER.UPLOAD_FILE' | translate"
          [icon]="icons.Loading"
          [ngClass]="{ 'svg32': isImpairedVersion, 'svg24 overline-2': !isImpairedVersion }"
          class="dark-gray-color loading-icon"
        />

        <span
          [ngClass]="{ 'h3-impaired': isImpairedVersion, 'body-2': !isImpairedVersion }"
          class="dark-gray-color"
          [matTooltip]="(file.status === 'PROCESSING' ? 'OTHER.UPLOAD_FILE' : 'OTHER.GENERATE_FILE') | translate"
        >
          {{
            ('OTHER.VERSION' | translate) +
              ' ' +
              file.versionNum +
              '.' +
              file.releaseNum +
              ' от ' +
              file.releaseDate +
              (file.releaseStatus === actualRelease ? ' (' + ('OTHER.ACTUAL' | translate) + ')' : '')
          }}
        </span>
      </div>
    </ng-container>
  </div>
</div>
